import React from "react";

interface Airline {
  nonRevAirlineName: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  airlines: Airline[];
}

const NonRevAirlinesModal: React.FC<Props> = ({ open, onClose, airlines }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-2xl h-fit max-h-[500px] rounded-lg shadow-xl p-6 flex flex-col">
        
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-2 mb-3">
          <h2 className="text-lg font-semibold">Non-Rev Airlines</h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>
            ✖
          </button>
        </div>

        {/* Table */}
         <div className="mt-4 flex-1 overflow-y-auto border rounded">
          <table className="w-full text-sm">
            <thead className="bg-blue-50 sticky top-0">
              <tr>
                <th className="border p-2 w-16 text-left">S.No</th>
                <th className="border p-2 text-left">Airline Name</th>
              </tr>
            </thead>

            <tbody>
              {airlines.map((airline, index) => (
                <tr key={index} className="hover:bg-blue-50">
                  <td className="border p-2">{index + 1}</td>
                  <td className="border p-2">{airline.nonRevAirlineName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        {/* <div className="text-right mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Close
          </button>
        </div> */}

      </div>
    </div>
  );
};

export default NonRevAirlinesModal;
